// SOAP改善提案に関する型定義

import { SoapContentItem } from '@/shared/types/yakurekiSoap'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

export interface SoapImprovementSuggestion {
  id: string
  event: string // YakurekiEvent ID (UUID)
  label: string // 提案タイトル
  explanation: string // 詳細説明
  category: 'basic' | 'kasan' | 'followup' // カテゴリ
  chatPrompt?: string // chat_promptから変換されるサーバー送信用プロンプト
  ruleIdentifier: string // rule_identifierから変換されるルール識別子
  status: 'pending' | 'applied' | 'dismissed'
  priority: number // 優先度 (0-10)
  createdAt: string // created_atから変換
  appliedAt?: string | null // applied_atから変換される適用日時
  dismissedAt?: string | null // dismissed_atから変換される却下日時
}

export interface SoapImprovementResponse {
  suggestions: SoapImprovementSuggestion[]
  generatedAt: string
}

// カテゴリ定義
export interface SoapImprovementCategory {
  id: 'basic' | 'kasan' | 'followup'
  label: string
  icon: string
  color: string
  priority: number
}

export const SOAP_IMPROVEMENT_CATEGORIES: SoapImprovementCategory[] = [
  {
    id: 'basic',
    label: '基本',
    icon: 'Description', // MUIアイコン名
    color: colorTokens.fg.default, // 統一されたグレー系
    priority: 1,
  },
  {
    id: 'kasan',
    label: '加算',
    icon: 'Paid', // MUIアイコン名
    color: colorTokens.fg.default, // 統一されたグレー系
    priority: 2,
  },
  {
    id: 'followup',
    label: 'フォローアップ',
    icon: 'Event', // MUIアイコン名
    color: colorTokens.fg.default, // 統一されたグレー系
    priority: 3,
  },
]

// 改善提案適用リクエスト
export interface ApplySuggestionRequest {
  suggestionId: string
}

// 改善提案適用レスポンス
export interface ApplySuggestionResponse {
  success: boolean
  message: string
  result?: {
    updatedSoap: {
      subjectives: SoapContentItem[]
      objectives: SoapContentItem[]
      assessments: SoapContentItem[]
      educationalPlans: SoapContentItem[]
      carePlans: SoapContentItem[]
      observationalPlans: SoapContentItem[]
      patientCondition?: {
        comprehension?: number | null
        appearance?: number | null
      }
    }
    aiResponse: string
    chatMessageId: string
    messageOrder: number
  }
}

// 改善提案却下リクエスト
export interface DismissSuggestionRequest {
  suggestionId: string
}

// 改善提案却下レスポンス
export interface DismissSuggestionResponse {
  success: boolean
  message?: string
  error?: string
}
